import { render, staticRenderFns } from "./relatorio.vue?vue&type=template&id=03c81236&"
import script from "./relatorio.vue?vue&type=script&lang=ts&"
export * from "./relatorio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports